import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import { QUERY_KEYS } from '@/remote/query-key';
import type {
  CreateSiteInspectionDto,
  SiteInspectionApiResponse,
  SiteInspectionResponse,
} from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useCreateInspectionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.inspections.createInspection],
    mutationFn: async (
      data: CreateSiteInspectionDto
    ): Promise<SiteInspectionResponse> => {
      const response =
        await XHRAuthorizedClient.post<SiteInspectionApiResponse>(
          ENDPOINTS.inspections.create,
          data
        );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
};
